import { render, staticRenderFns } from "./last-classification.page.vue?vue&type=template&id=192a96f6"
import script from "./last-classification.page.vue?vue&type=script&lang=ts"
export * from "./last-classification.page.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports